import { render } from "./EventviewBetOutcome.vue?vue&type=template&id=3e7acd33"
import script from "./EventviewBetOutcome.vue?vue&type=script&lang=js"
export * from "./EventviewBetOutcome.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__